var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":_vm._f("trans")('budget')}},[_c('budget-edit')],1),_c('el-tab-pane',{attrs:{"label":_vm._f("trans")('type')}},[_c('allocation-type-edit')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }